import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { alchemy } from "../utils/alchemy";

function BlockDetails() {
  const { blockNumber } = useParams();
  const [block, setBlock] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchBlock() {
      try {
        const blockData = await alchemy.core.getBlockWithTransactions(
          parseInt(blockNumber)
        );
        setBlock(blockData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching block:", error);
        setLoading(false);
      }
    }

    fetchBlock();
  }, [blockNumber]);

  if (loading) {
    return <div className="loading">Loading block details...</div>;
  }

  if (!block) {
    return <div className="error">Block not found</div>;
  }

  return (
    <div className="page">
      <h1>Block #{block.number}</h1>

      <div className="details-grid">
        <div className="detail-item">
          <div className="label">Timestamp</div>
          <div className="value">
            {new Date(block.timestamp * 1000).toLocaleString()}
          </div>
        </div>

        <div className="detail-item">
          <div className="label">Transactions</div>
          <div className="value">{block.transactions.length}</div>
        </div>

        <div className="detail-item">
          <div className="label">Miner</div>
          <div className="value">
            <Link to={`/address/${block.miner}`}>{block.miner}</Link>
          </div>
        </div>

        <div className="detail-item">
          <div className="label">Gas Used</div>
          <div className="value">
            {parseInt(block.gasUsed._hex, 16).toLocaleString()}
          </div>
        </div>

        <div className="detail-item">
          <div className="label">Gas Limit</div>
          <div className="value">
            {parseInt(block.gasLimit._hex, 16).toLocaleString()}
          </div>
        </div>

        <div className="detail-item">
          <div className="label">Base Fee Per Gas</div>
          <div className="value">
            {block.baseFeePerGas
              ? (parseInt(block.baseFeePerGas._hex, 16) / 1e9).toFixed(2) +
                " Gwei"
              : "N/A"}
          </div>
        </div>

        <div className="detail-item full-width">
          <div className="label">Hash</div>
          <div className="value mono">{block.hash}</div>
        </div>

        <div className="detail-item full-width">
          <div className="label">Parent Hash</div>
          <div className="value mono">
            <Link to={`/block/${block.number - 1}`}>{block.parentHash}</Link>
          </div>
        </div>
      </div>

      <h2>Transactions ({block.transactions.length})</h2>
      <div className="transactions-list">
        {block.transactions.length === 0 ? (
          <p>No transactions in this block</p>
        ) : (
          block.transactions.map((tx) => (
            <div key={tx.hash} className="transaction-card">
              <Link to={`/tx/${tx.hash}`} className="tx-hash">
                {tx.hash}
              </Link>
              <div className="tx-meta">
                <span>
                  From: <Link to={`/address/${tx.from}`}>{tx.from}</Link>
                </span>
                <span>
                  To:{" "}
                  {tx.to ? (
                    <Link to={`/address/${tx.to}`}>{tx.to}</Link>
                  ) : (
                    "Contract Creation"
                  )}
                </span>
                <span>
                  Value: {(parseInt(tx.value._hex, 16) / 1e18).toFixed(4)} ETH
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default BlockDetails;
